import * as React from 'react';
import { t } from '../../../../services/HelperService';
import {
  CardHeader,
  Chip,
  ChipRow,
  MetaRow,
  isPastDate,
  shortDate,
  shortTime,
  translateKey,
} from './builtInCardParts';

export const ActivityBuiltInCard = ({ card, data }) => {
  const isOpen = !data.Closed && !data.Cancelled;
  const overdue = isOpen && isPastDate(data.End ?? data.Start);
  const when = data.AllDay
    ? `${shortDate(data.Start)} · ${t('All day')}`
    : `${shortDate(data.Start)} ${shortTime(data.Start)} - ${shortTime(data.End)}`;

  return (
    <div>
      <CardHeader
        title={data.Subject || card.description}
        repName={data.RepName || data.TeamName}
      />
      <ChipRow style={{ marginTop: 4 }}>
        {data.Category && <Chip tone="blue">{data.Category}</Chip>}
        {data.ActivityType && <Chip tone="gray">{translateKey(data.ActivityType)}</Chip>}
        {data.Cancelled && <Chip tone="red">{t('Cancelled')}</Chip>}
        {!data.Cancelled && data.Closed && <Chip tone="green">{t('Closed')}</Chip>}
        {/* Activity.Confirmed is a nullable bit; a never-ticked checkbox saves as null, so treat any falsy value as unconfirmed (matches ActivityLinkCtrl / Calendar). */}
        {!data.Cancelled && !data.Closed && !data.Confirmed && <Chip tone="amber">{t('Unconfirmed')}</Chip>}
      </ChipRow>
      <MetaRow icon="schedule" danger={overdue}>
        {when}{overdue ? ` · ${t('overdue')}` : ''}
      </MetaRow>
      {(data.ContactName || data.CompanyName) && (
        <MetaRow icon="person">
          {data.ContactName || data.CompanyName}
          {data.ContactName && data.CompanyName ? ` · ${data.CompanyName}` : ''}
        </MetaRow>
      )}
      {data.JobReference && <MetaRow icon="work">{data.JobReference}</MetaRow>}
      {data.Suburb && <MetaRow icon="place">{data.Suburb}</MetaRow>}
    </div>
  );
};
